import React from 'react';
import {
  DndContext,
  closestCorners,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy
} from '@dnd-kit/sortable';
import { useDragContext } from '../context';

export function DragSource({
  onDragEnd,
  children,
}) {
  const { dispatch, state: { items } } = useDragContext();

  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));
  
  function setItems(fn) {
    const new_array = fn(items);
    
    dispatch({
      type: 'SET_ITEMS',
      payload: new_array
    });
    return new_array;
  }
  const dragStarted = () => {
    console.log('DRAG!!!!');
  }
  return (
    <DndContext
      autoScroll={false}
      sensors={sensors}
      collisionDetection={closestCorners}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={items.map((i) => i.id)}
        strategy={rectSortingStrategy}
      >
        <div
        style = {{
          width: '100%',
          height: '100%'
        }}
        >
        {
          children
        }
        </div>
      </SortableContext>
    </DndContext>
  );

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active.id !== over.id) {
      const order = setItems((items) => {
        const oldIndex = items.findIndex((i) => i.id === active.id);
        const newIndex = items.findIndex((i) => i.id === over.id);

        return arrayMove(items, oldIndex, newIndex);
      });
      const _order = order.map(item => parseInt(item.id));
      onDragEnd(_order);
    }
  }
}
